/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Submit_ProgressInputs */

const en_us2_body_assessment_submit_progress = /** @type {(inputs: Body_Assessment_Submit_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending your photos…`)
};

const pt_br2_body_assessment_submit_progress = /** @type {(inputs: Body_Assessment_Submit_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando as suas fotos…`)
};

const es_419_body_assessment_submit_progress = /** @type {(inputs: Body_Assessment_Submit_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando tus fotos…`)
};

const pt_pt2_body_assessment_submit_progress = /** @type {(inputs: Body_Assessment_Submit_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A enviar as tuas fotos…`)
};

const fr_fr2_body_assessment_submit_progress = /** @type {(inputs: Body_Assessment_Submit_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi de tes photos…`)
};

const de_de2_body_assessment_submit_progress = /** @type {(inputs: Body_Assessment_Submit_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Fotos werden gesendet…`)
};

const it_it2_body_assessment_submit_progress = /** @type {(inputs: Body_Assessment_Submit_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio delle foto…`)
};

/**
* | output |
* | --- |
* | "Sending your photos…" |
*
* @param {Body_Assessment_Submit_ProgressInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_submit_progress = /** @type {((inputs?: Body_Assessment_Submit_ProgressInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Submit_ProgressInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_submit_progress(inputs)
	if (locale === "es-419") return es_419_body_assessment_submit_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_submit_progress(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_submit_progress(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_submit_progress(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_submit_progress(inputs)
	return en_us2_body_assessment_submit_progress(inputs)
});
export { body_assessment_submit_progress as "body-assessment.submit_progress" }